export function unwrap(envelope) {
  if (!envelope?.success) {
    throw new Error(envelope?.errorMessage || envelope?.error || 'Erro na requisição')
  }
  return { data: envelope.result, metadata: envelope.metadata }
}
